import {
    EntityListWithPagination,
    EntityWithIdAndDescription,
    PaginacionRequest,
    schemaEntityListWithPagination
} from "../../../types";
import {
    DumpTruckInsertDTO,
    DumpTruckFilterDTO,
    DumpTruckViewDTO,
    schemaDumpTruckView, DumpTruckUpdateDTO, DumpTruckSummarySummary
} from "../types/dto";
import { HttpAxiosRequest } from "../../../http/httpAxiosBase";
import {OrderStatusTypes} from "../../orders/types/enum";
import {OrderUpdateDTO} from "../../orders/types/dto";

export const getEndpoint = (url = ''): string => `volquete/${url}`;

export const HttpDumpTrucks = {
    get: (pagination: PaginacionRequest, filter: DumpTruckFilterDTO): Promise<EntityListWithPagination<DumpTruckViewDTO>> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(getEndpoint(``), {
            ...pagination,
            ...filter,
        })
            .then(response => {
                const parsed = schemaEntityListWithPagination(schemaDumpTruckView).safeParse(response);

                if (!parsed.success) {
                    console.error('Error de validación Zod:', parsed.error.issues);

                    return Promise.reject(new Error('La respuesta de la API no tiene el formato esperado.'));
                }

                return parsed.data;
            })
            .catch(error => {
                console.error('Error de red o del servidor:', error);

                return Promise.reject(new Error('No se pudo obtener la lista de volquetes.'));
            });
    },

    put: (dumpTruckId: number, data: DumpTruckUpdateDTO): Promise<any> => {
        return HttpAxiosRequest.put(getEndpoint(`${dumpTruckId}`), data)
    },

    post: (data: DumpTruckInsertDTO): Promise<any> => {
        return HttpAxiosRequest.post(getEndpoint(``), data);
    },

    updateStatus: (dumpTruckId: number, statusCode: OrderStatusTypes): Promise<any> => {
        return HttpAxiosRequest.put(getEndpoint(`${dumpTruckId}/estado/${statusCode}`), {}
        )
    },

    getSummary:(): Promise<DumpTruckSummarySummary> => {
        return HttpAxiosRequest.get(getEndpoint(`resumen`))
    },

    getStatusTypes: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`estados`));
    },

    getTypes: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`tipos`));
    },

} as const;
